import React from 'react';
import { Users, FileText, CheckCircle, XCircle, RefreshCw } from 'lucide-react';
import styles from './BackofficeHeader.module.scss';
import { BackofficeStats } from '../../../../types/backoffice.ts';

interface BackofficeHeaderProps {
  stats: BackofficeStats;
  loading?: boolean;
  onRefresh?: () => void;
  identityPendingCount?: number;
}

const BackofficeHeader: React.FC<BackofficeHeaderProps> = ({
  stats,
  loading = false,
  onRefresh,
  identityPendingCount,
}) => {
  const resolvedIdentityPending =
    typeof identityPendingCount === 'number'
      ? identityPendingCount
      : stats.totalPendingIdentities;

  const statCards = [
    {
      Icon: Users,
      label: 'Identidades Pendientes',
      value: resolvedIdentityPending,
      color: '#ff9800'
    },
    {
      Icon: FileText,
      label: 'Proyectos Pendientes',
      value: stats.totalPendingAnteProyectos,
      color: '#2196f3'
    },
    {
      Icon: CheckCircle,
      label: 'Aprobados Hoy',
      value: stats.totalApprovedToday,
      color: '#4caf50'
    },
    {
      Icon: XCircle,
      label: 'Rechazados Hoy',
      value: stats.totalRejectedToday,
      color: '#f44336'
    }
  ];

  return (
    <div className={styles.header}>
      <div className={styles.titleSection}>
        <div className={styles.titleWrapper}>
          <div>
            <h1 className={styles.title}>Backoffice</h1>
            <p className={styles.subtitle}>Panel de administración y validación</p>
          </div>
          {onRefresh && (
            <button 
              className={styles.refreshButton}
              onClick={onRefresh}
              disabled={loading}
              title="Actualizar datos"
            >
              <RefreshCw size={20} className={loading ? styles.spinning : ''} />
              Actualizar
            </button>
          )}
        </div>
      </div>
      
      <div className={styles.statsGrid}>
        {statCards.map((card, index) => (
          <div key={index} className={styles.statCard}>
            <div className={styles.iconWrapper} style={{ backgroundColor: `${card.color}15` }}>
              <card.Icon 
                className={styles.icon}
                style={{ color: card.color }}
                size={24}
              />
            </div>
            <div className={styles.statContent}>
              <span className={styles.statLabel}>{card.label}</span>
              <span className={styles.statValue}>
                {loading ? '...' : card.value}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BackofficeHeader;

